<template>
    <BaseDialog 
        :max_width="`80%`"
        :dialog="dialog"
        title="Utente"
        v-on:close_dialog="closeDialog">
        <v-form v-model="valid" ref="form" v-if="user!=null">
            <div class="d-flex flex-column">
                <div class="d-flex">
                    <v-text-field dense outlined
                        label="nome e cognome*"
                        v-model="user.name"
                        :rules="[rules.mandatory, rules.nameRules]"
                    ></v-text-field>
                    <v-text-field dense outlined
                        class="ml-2"
                        label="numero telefonico*"
                        v-model="user.phone"
                        :rules="[rules.mandatory, rules.nameRules]"
                    ></v-text-field>
                </div>
                <div class="d-flex">
                    <v-text-field dense outlined
                        label="username*"
                        v-model="user.username"
                        :rules="[rules.mandatory, unique_username]"
                    ></v-text-field>
                    <v-text-field dense outlined
                        v-if="justCreated"
                        class="ml-2"
                        label="password*"
                        id="id"
                        v-model="user.password"
                        :rules="[rules.mandatory, rules.nameRules(user.password, 8)]"
                    ></v-text-field>
                    <v-text-field dense outlined
                        label="email*"
                        class="ml-2"
                        v-model="user.email"
                        :rules="[rules.mandatory, rules.emailRules]"
                    ></v-text-field>
                </div>
                <div class="d-flex">
                    <v-autocomplete dense outlined
                        label="ente*"
                        small-chips
                        clearable
                        :items="orgs"
                        v-model="user.org_id"
                        item-text="value.name"
                        item-value="id"
                        :rules="[rules.mandatory, rules.arrayRules]"
                        />
                    <v-autocomplete dense outlined
                        label="ruoli*"
                        small-chips
                        deletable-chips
                        multiple
                        hide-selected
                        clearable
                        :items="roles"
                        item-value="id"
                        item-text="name"
                        v-model="user.roles"
                        :rules="[rules.mandatory, rules.arrayRules]"
                        class="pl-2"
                        >
                        </v-autocomplete>
                </div>
                <div class="d-flex">
                    <v-text-field dense outlined
                        label="note per l'utente"
                        v-model="user.notes"
                    ></v-text-field>
                </div>
                <v-divider />
                <div class="d-flex text-subtitle-1 text-uppercase pt-2 pb-1">dati generazione automatica codice report</div>
                    <div class="d-flex">
                        <v-text-field dense outlined
                            label="codice utente"
                            v-model="user.code"
                            :rules="[rules.mandatory]"
                            />
                    </div>
                    <div class="pt-2" v-if="$store.state.config.enable_report_code_gen">
                    <div class="d-flex text-subtitle-2 text-uppercase">contatori</div>
                    <div class="d-flex flex-column">
                        <span class="pl-4">Verificazione Periodica NAWI: <i>{{user.report_seq.N}}</i></span>
                        <span class="pl-4">Verificazione Periodica AWI: <i>{{user.report_seq.A}}</i></span>
                        <span class="pl-4">Taratura scientifica: <i>{{user.report_seq.iso}}</i></span>
                        <span class="pl-4">Taratura scientifica semplificata bilance: <i>{{user.report_seq.iso_simple}}</i></span>
                        <span class="pl-4">Taratura semplificata sonda umidità: <i>{{user.report_seq.humidity}}</i></span>
                        <span class="pl-4">Taratura scientifica dosatore litri: <i>{{user.report_seq.doserL}}</i></span>
                    </div>
                    <div class="d-flex pt-2">
                        <v-row no-gutters>
                            <v-col cols="4">
                                <NumericField dense outlined
                                    label="verificazione periodica NAWI"
                                    v-model="user.report_seq.N"
                                    v-can="{obj_type:'user', action: 'edit_report_seq'}"
                                    :precision="0"
                                />
                            </v-col>
                            <v-col cols="4">
                                <NumericField dense outlined
                                    class="pl-2"
                                    label="verificazione periodica AWI"
                                    v-model="user.report_seq.A"
                                    v-can="{obj_type:'user', action: 'edit_report_seq'}"
                                    :precision="0"
                                />
                            </v-col>
                        </v-row>
                    </div>
                    <div class="d-flex pt-2">
                        <v-row no-gutters>
                            <v-col cols="4">
                                <NumericField dense outlined
                                    class="pl-2"
                                    label="taratura scientifica"
                                    v-model="user.report_seq.iso"
                                    v-can="{obj_type:'user', action: 'edit_report_seq'}"
                                    :precision="0"
                                />
                            </v-col>
                        </v-row>
                    </div>
                    <div class="d-flex pt-2">
                        <v-row no-gutters>
                            <v-col cols="4">
                                <NumericField dense outlined
                                    class="pl-2"
                                    label="taratura semplificata bilance"
                                    v-model="user.report_seq.iso_simple"
                                    v-can="{obj_type:'user', action: 'edit_report_seq'}"
                                    :precision="0"
                                />
                            </v-col>
                            <v-col cols="4">
                                <NumericField dense outlined
                                    class="pl-2"
                                    label="taratura semplificata sonda umidità"
                                    v-model="user.report_seq.humidity"
                                    v-can="{obj_type:'user', action: 'edit_report_seq'}"
                                    :precision="0"
                                />
                            </v-col>
                            <v-col cols="4">
                                <NumericField dense outlined
                                    class="pl-2"
                                    label="taratura semplificata dosatori litri"
                                    v-model="user.report_seq.doserL"
                                    v-can="{obj_type:'user', action: 'edit_report_seq'}"
                                    :precision="0"
                                />
                            </v-col>
                        </v-row>
                    </div>
                </div>
                <v-divider />
                <div v-if="user.roles.length>0">
                    <div class="text-uppercase text-subtitle-1">Report</div>
                    <div class="d-flex align-center my-2" v-for="rep_type of types" :key="'report_type_'+rep_type.id">
                        <v-checkbox 
                            v-model="report_type[rep_type.id].enabled"
                            :label="rep_type.name"
                            hide-details
                            @change="changeSelection(report_type, rep_type.id)"
                            class="d-flex ma-0"
                        />
                        <span v-if="rep_type.id == 'leg' && report_type['leg'].enabled">
                        <v-autocomplete dense outlined
                            class="d-flex pl-4"
                            label="Abilitazione per verificazioni legali:*"
                            small-chips
                            multiple
                            clearable
                            hide-details
                            :items="families"
                            v-model="report_type[rep_type.id].families"
                            :rules = "[rules.mandatory, rules.arrayRules]"
                            >
                        </v-autocomplete></span>
                    </div>
                </div>
                <div v-if="user.roles.length>0 && user.roles.includes('reviewer')">
                    <div class="text-subtitle-1 text-uppercase" >Review</div>
                    <div class="d-flex align-center my-2" v-for="rev_type of types" :key="'review_type_'+rev_type.id">
                        <v-checkbox 
                            v-model="review_type[rev_type.id].enabled"
                            :label="rev_type.name"
                            @change="changeSelection(review_type, rev_type.id)"
                            hide-details
                            class="d-flex ma-0"
                        />
                            
                        <span v-if="rev_type.id == 'leg' && review_type['leg'].enabled">
                        <v-autocomplete dense outlined
                            class="d-flex pl-4"
                            label="Abilitazione per verificazioni legali:*"
                            small-chips
                            multiple
                            clearable
                            hide-details
                            :items="families"
                            v-model="review_type[rev_type.id].families"
                            :rules = "[rules.mandatory, rules.arrayRules]">
                        </v-autocomplete>
                        </span>
                    </div>
                </div>
                <div class="d-flex">
                    <v-col cols="6">
                        <v-progress-linear
                            v-if="uploading"
                            color="primary"
                            indeterminate
                            rounded
                            height="6"
                        ></v-progress-linear>
                        
                        <v-img v-if="user.sign_ref" :src="'/mastercalFiles'+user.sign_ref"></v-img>
                    </v-col>
                    <v-col cols="6" class="d-flex justify-end">
                        <div class="d-flex flex-column">
                        <VueUploadComponent
                            ref="upload"
                            v-model="files"
                            input-id="file1"
                            class="btn"
                            accept="image/*"
                            @input-file="inputFile"
                            @input-filter="inputFilter"
                            >
                            <v-btn :disabled="$store.state.offline" elevation-2 color="primary" class="my-2">
                                <span class="pr-1" v-if="user.sign_ref">aggiorna</span><span class="pr-1" v-else>carica</span> firma
                            </v-btn>
                        </VueUploadComponent>
                        <span class="pr-1">Formati supportati: PNG, JPEG, JPG</span>
                        </div>
                    </v-col>
                </div>
            </div> 
        </v-form>
        <template v-slot:action>
            <v-alert v-if="errorMessage" type="warning">
                {{errorMessage}} 
            </v-alert>
            <div class="d-flex align-center justify-center my-4">
                <v-btn :disabled="$store.state.offline || !valid || !hasSign" color="primary" @click="saveAndClose">Conferma</v-btn>
                <v-btn text @click="closeDialog">Annulla</v-btn>
            </div>
        </template>
    </BaseDialog>
</template>

<script>
import {getModel} from "../../utils/model"
import {f_rules} from "../../utils/commonUtils"
import {i_roles_reg} from "../../utils/rolesManagement"
import {report_type, leg_families} from "../../utils/common"
import {searchDesign, orderByFields} from "../../utils/dbUtility"
// import _ from 'lodash'
import VueUploadComponent from "vue-upload-component";
import BaseDialog from '../../components/dialogs/BaseDialog'

export default {
components: {BaseDialog, VueUploadComponent},
data() {
    return {
        dialog: false,
        roles: i_roles_reg,
        user: null,  
        valid: false,
        justCreated: true,
        rules: f_rules,
        value: false,
        types: {},
        families: [],
        type_list: [],
        family_list: [],
        orgs: [],
        users: [],
        unique_username: v => this.isDuplicatedUsername(v),
        report_type: {},
        review_type: {},
        view: false,
        uploading: false,
        files: [],
        failed: false,
        errorMessage: null
    }
},
created() {
    this.types = Object.values(report_type)
    this.families = Object.keys(leg_families)
    this.dialog = false
},
async mounted() {
    let res = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'key', "organism", false)
    this.orgs = orderByFields(res, {value: ['value.name'], order: ['asc']})   
},
methods: {
    isDuplicatedUsername(username) {
        let user = this.user
        if (username) {
            let match = _.find(this.$store.state.users, function(o) {
                if (user._id != o._id) {
                    return o.username.toLowerCase() == username.toLowerCase();
                } 
            });
            return match==undefined ? true : 'username duplicato'
        }
        return false
    },
    async reset(userdata){
        this.view = false
        this.user = null
        this.family_list = []
        this.type_list = []
        this.errorMessage = null
        console.log("DEBUG user reset", userdata)
        if(userdata != undefined && userdata != null){
            let res = await this.axios.get("/mastercal/users/" + userdata._id).catch(error => {
                console.log("error status", error);
                this.errorMessage = "errore di connessione al server o utente non trovato. Se il problema persiste contattare l'amministratore"
            });
            this.user = res.data
            this.justCreated = false;
            if (!this.user.report_type || _.isEmpty(this.user.report_type)) {
                this.buildQualifications('report_type')
            }
            if ( !this.user.review_type || _.isEmpty(this.user.report_type)) {
                this.buildQualifications('review_type')
            }
        } else {
            this.justCreated = true
            let User = getModel('User')
            this.user  = User({created_by: this.$store.state.user._id})
            this.buildQualifications('report_type')
            
            this.buildQualifications('review_type')
        }
        this.report_type = this.user.report_type
        this.review_type = this.user.review_type
        this.view = true
        this.dialog = true
    },
    closeDialog(){
        this.dialog = false
    },
    async saveAndClose(){
        console.log("current item", this.user)
        this.errorMessage = null
        let res = null
        let user = {...this.user}
        
        user.report_seq.N = parseInt(user.report_seq.N)
        user.report_seq.iso = parseInt(user.report_seq.iso)
        user.report_seq.iso_simple = parseInt(user.report_seq.iso_simple)
        user.report_seq.A = parseInt(user.report_seq.A)
        user.report_seq.humidity = parseInt(user.report_seq.humidity)
        user.report_seq.doserL = parseInt(user.report_seq.doserL)

        if(this.justCreated){
            res = await this.axios.post('mastercal/users/', user).catch(error => {
                console.log("error status", error);
                this.errorMessage = "errore di connessione al server - riprovare. Se il problema persiste contattare l'amministratore"
            });
        } else {
            res = await this.axios.put('mastercal/users/'+this.user._id, user).catch(error => {
                console.log("error status", error);
                this.errorMessage = "errore di salvataggio sul server - Chiudere la finestra e riprovare. Se il problema persiste contattare l'amministratore"
            });
        }
        if (res && res.data) {
            this.$emit('updateUsersList', res.data, this.justCreated)
            this.closeDialog();
        }
    },
    inputFilter: function (newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
            // Filter non-pdf file
            if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
            console.log("filtered non image file")
            return prevent()
            }
        }
    },
    async inputFile(){
        // this.$refs.upload.active = true
        this.uploading = true;
        this.failed = false
        let uploadedFile = this.files[0].file
        //console.log("file selected", uploadedFile.name)
        let extensionIndex =  uploadedFile.name.lastIndexOf('.')
        let extension = uploadedFile.name.slice(extensionIndex)
        let uuidv1 = require('uuid/v1')
        let name = uuidv1()+extension
        console.log("file selected NAME", name)
        let form = new window.FormData()
        form.append('file', uploadedFile)
        let res = await this.axios.post(
            "/mastercal/orgs/files", form, 
            {
                headers: {"Content-Type": "multipart/formdata"},
                params: {file_name: name}
            }).catch((error) => {
                if(error){
                    console.log("error status", error);
                    this.failed = true
                    this.uploading = false
                }
            })
        console.log("result axios", res)
        if(res.status == 200){
            console.log("confirmed update", res.data)
            this.user.sign_ref = res.data
        }
        this.uploading = false
    },

    /*buildDict(){
        for(let item of this.type_list){
            if(item){
                this.user.report_type[item].enabled = true
                if(item == 'leg'){
                   this.user.report_type[item].families = this.family_list
                }
            }
        }
    },*/
    changeSelection(permission, r_type) {
        this.$set(permission, r_type['enabled'], permission[r_type].enabled)
        if (permission[r_type].enabled && r_type == 'leg'){
            this.$set(permission[r_type], 'families', this.families)
        } else {
            this.$set(permission[r_type], 'families', [])
        }
    }, 
    /*changeRoles() {
        if (this.user.roles.includes('reviewer')) {
            this.buildQualifications('review_type')
    
        }
    },*/
    buildQualifications(permission_dict){
        let Qualification = getModel('Qualification')
        console.log('QUALIFICATION', permission_dict )
        this.user[permission_dict] = {}
        for(let item of this.types){
            this.user[permission_dict][item.id] = new Qualification()
        }
    }
},
computed: {
    computedCheck(){
        console.log("CMPT TRIGGERED")
        if(this.type_list.includes('leg')){
            return true
        } else {
            return false
        }
    },
    hasSign(){
        if(this.user && this.user.sign_ref){
            return true
        } else {
            return false
        }
    }
},
}
</script>

<style>

</style>
